const initWeatherInfo = () => {
  const navbarLocationItem = document.getElementById('user-menu-location');
  if (null === navbarLocationItem) {
    return;
  }

  const weatherBoxes = document.getElementsByClassName('weather-box');
  const xhr = new XMLHttpRequest();

  navbarLocationItem.addEventListener('mouseenter', function temperatureCalculation() {
    if (weatherBoxes.length !== 0 && xhr.readyState === XMLHttpRequest.UNSENT) {
      [].forEach.call(weatherBoxes, function (weatherBox) {
        const url = `${weatherBox.getAttribute('data-url')}?postcode=${weatherBox.getAttribute('data-postalcode')}&city=${weatherBox.getAttribute('data-city')}`;

        xhr.onload = function () {
          if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
            const data = xhr.responseText;

            const dataArray = JSON.parse(data);
            if ('temperature' in dataArray['data'] && null !== dataArray['data']['temperature']) {
              const temperature = weatherBox.querySelector('.temperature');
              const temperatureIconHtml = `<svg height="38" width="38"><use xlink:href="/assets/images/front/layout/weather-icons.svg#weather-code-${dataArray['data']['weather_code']}"></use></svg>`;

              temperature.innerHTML = `${dataArray['data']['temperature']}<span>°</span>${temperatureIconHtml}`;
            }

            navbarLocationItem.removeEventListener('mouseenter', temperatureCalculation);
          }
        };

        xhr.open("GET", url, true);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.send();
      });
    }
  });
};

export default initWeatherInfo;

